import React from 'react'

import { Tooltip } from '../../../../atoms'

const TooltipAnonymous = () => {
  return (
    <Tooltip
      content="L'identité du client est dévoilée lorsque la réservation est confirmée"
      contentClassName='p-4'
      position='top-right'
    >
      <div className='flex h-5 w-5 cursor-default items-center justify-center rounded-full bg-grey-400'>
        <span>?</span>
      </div>
    </Tooltip>
  )
}

export default TooltipAnonymous
